import React from 'react';
import styles from "./annual-savings-summary.module.scss";
import poweredByLogo from "../images/ii-logo.png";
import poweredByLogo2x from "../images/ii-logo@2x.png";
import poweredByLogo3x from "../images/ii-logo@3x.png";
import poweredByLogoMobile from "../images/ii-logo-mobile.png";
import poweredByLogoMobile2x from "../images/ii-logo-mobile@2x.png";
import poweredByLogoMobile3x from "../images/ii-logo-mobile@3x.png";

import { ReactComponent as InfoIcon } from '../images/info-icon.svg';
import classNames from "classnames";
import { Col, Row, Tooltip } from "antd";

let cx = classNames.bind(styles);

const AnnualSavingsSummary = (props) => (
    <div>
        <div className={styles.annualSavings}>Annual Savings Summary</div>
    
        <div className = { styles.savingsHeader } >
            <Row type="flex" justify="center" align="middle">
                <Col xs={12} md={4} lg={6}>
                    <img src={poweredByLogo}
                         srcSet={`
                            ${poweredByLogo2x} 2x, 
                            ${poweredByLogo3x} 3x
                          `}
                         className={styles.poweredByLogo} alt="Powered By HP Instant Ink"/>
                    <img src={poweredByLogoMobile}
                         srcSet={`
                            ${poweredByLogoMobile2x} 2x, 
                            ${poweredByLogoMobile3x} 3x
                          `}
                         className={styles.poweredByLogoMobile} alt="HP Instant Ink"/>
                </Col>
                <Col xs={12} md={5} className={cx(styles.summaryCol, styles.alt)}>
                    <div className={cx(styles.summary)}>
                        ${props.perYear > 0 ? props.perYear.toFixed(0) : '0'} <span className={styles.detail}>Per year <Tooltip placement="top" overlayClassName={styles.savingsTip} title={(
                        <div>Your spending minus the annual cost of your recommended plan. </div>
                        )}><div className={styles.infoWrap2}><InfoIcon/></div></Tooltip></span>
                    </div>
                </Col>
                <div className={styles.break}/>
                <Col xs={10} md={8} lg={6} className={cx(styles.summaryCol, styles.popover__wrapper)}>
                    <div className={cx(styles.summary, styles.tripNo)}>{props.panicTrips}</div>
                    <span className={styles.detail}>Panicked trips to store <Tooltip placement="top" overlayClassName={styles.savingsTip} title={(
                        <div>On average people run out of ink unexpectedly 50% of the time.</div>
                        )}><div className={styles.infoWrap2}><InfoIcon/></div></Tooltip></span>
                </Col>
                <Col xs={{span: 13, offset: 1}} md={{span: 7, offset: 0}} className={cx(styles.summaryCol, styles.popover__wrapper)}>
                    <div className={cx(styles.summary, styles.carbon)}>80%</div>
                    <span className={styles.detail}>Carbon Footprint <Tooltip placement="top" overlayClassName={styles.savingsTip} title={(
                        <div>With Instant Ink we use less packaging which, means less waste. <a href="#" onClick={(evt) => { evt.preventDefault(); document.getElementById('recycle').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"}); }}>See more</a>.</div>
                        )}><div className={styles.infoWrap2}><InfoIcon/></div></Tooltip></span>
                </Col>
            </Row>
        </div>
    </div>
);

export default AnnualSavingsSummary;
